document.addEventListener('DOMContentLoaded', () => {
  const readMore = document.querySelector('.collection-read-more');
  const description = document.querySelector('.collection__description--short');
  readMore.addEventListener('click', (e) => {
    e.preventDefault();
    console.log('clicked');
    
    description.style.maxHeight = 'none';
    description.style.overflow = 'visible';
    readMore.style.display = 'none';
  });
});